import { useEffect, useState } from "react";
import { Loader2, Shield, CheckCircle2, XCircle, Monitor } from "lucide-react";
import { api } from "../../lib/api";

export default function LoginActivityPanel() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/admin/login-events?limit=100")
            .then((r) => setEvents(r.data || []))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="flex justify-center py-16"><Loader2 className="w-7 h-7 animate-spin text-[#1E3A8A]" /></div>;

    return (
        <div data-testid="admin-login-activity">
            <h2 className="font-heading text-2xl font-bold mb-1">Login Activity</h2>
            <p className="text-sm text-slate-500 mb-5">
                Every successful and failed admin sign-in over the last 100 events. Audit regularly for suspicious access.
            </p>

            {events.length === 0 ? (
                <div className="text-center py-16 text-slate-400">
                    <Shield className="w-10 h-10 mx-auto mb-3 text-slate-300" />
                    <div className="text-sm">No login activity yet.</div>
                </div>
            ) : (
                <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
                    <table className="w-full text-sm">
                        <thead className="bg-slate-50 border-b border-slate-200">
                            <tr className="text-left text-[11px] uppercase tracking-[0.12em] text-slate-500">
                                <th className="px-4 py-3 font-semibold">Status</th>
                                <th className="px-4 py-3 font-semibold">Email</th>
                                <th className="px-4 py-3 font-semibold">IP</th>
                                <th className="px-4 py-3 font-semibold hidden md:table-cell">Device</th>
                                <th className="px-4 py-3 font-semibold">When</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {events.map((e) => (
                                <tr key={e.id} data-testid={`login-event-${e.id}`} className="hover:bg-slate-50">
                                    <td className="px-4 py-3">
                                        {e.success ? (
                                            <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 text-[11px] font-semibold">
                                                <CheckCircle2 className="w-3 h-3" /> Success
                                            </span>
                                        ) : (
                                            <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-red-50 text-red-700 text-[11px] font-semibold">
                                                <XCircle className="w-3 h-3" /> Failed
                                            </span>
                                        )}
                                    </td>
                                    <td className="px-4 py-3 font-medium text-[#0F172A]">{e.email}</td>
                                    <td className="px-4 py-3 text-slate-600 font-mono text-xs">{e.ip || "—"}</td>
                                    <td className="px-4 py-3 hidden md:table-cell text-slate-500 text-xs">
                                        <div className="flex items-center gap-1.5 max-w-[280px] truncate">
                                            <Monitor className="w-3.5 h-3.5 shrink-0" />
                                            <span className="truncate">{e.user_agent || "—"}</span>
                                        </div>
                                    </td>
                                    <td className="px-4 py-3 text-slate-500 text-xs whitespace-nowrap">
                                        {new Date(e.created_at).toLocaleString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
